module.exports = __webpack_public_path__ + "media/bg2.66c2e5ee.mp4";